import { useSearchParams } from 'react-router-dom'

export default function ReservationButton({
  reservationUrl,
  label
}: {
  reservationUrl: string | null | undefined
  label: string | null | undefined
}) {
  const [searchParams] = useSearchParams()
  const hideReservation = searchParams.get('hide_reservation')

  if (hideReservation === 'true' || !reservationUrl || !label) {
    return null
  }

  return (
    <div className="fixed  z-10 w-full bottom-0 left-0">
      <a
        href={reservationUrl}
        rel="noopener noreferrer"
        target="_blank"
        className={`h-[50px] w-full max-w-[768px] mx-auto text-[12px] tracking-[0.02em] font-mammaTitle uppercase
      bg-primary text-tertiary px-6 flex items-center justify-center
      no-underline`}
      >
        {label}
      </a>
    </div>
  )
}
